import { MdAccountCircle } from "react-icons/md";
import { useSelector } from "react-redux";

export default function VerifyId({
    onStartVerification,
}) {
    const user = useSelector((state) => state.auth.user);

    return (
        <div className="min-h-screen w-full bg-black flex flex-col items-center text-center px-4">

            {/* Header */}
            <div className="w-full flex justify-center pt-6 relative">
                <h1 className="text-red-500 font-semibold text-lg">
                    Become a Host on Red Video Chat!
                </h1>
            </div>

            {/* Content */}
            <div className="flex flex-col items-center justify-center flex-1">

                <MdAccountCircle className="text-gray-300 text-3xl w-12 h-12" />

                {/* Title */}
                <h2 className="text-red-500 font-semibold text-lg mb-2">
                    Verify Your ID
                </h2>

                {/* Message */}
                <p className="text-gray-300 text-sm max-w-xs mb-4">
                    To become a host on Red Video Chat, you need to verify your ID information.
                </p>

                {/* Info Box */}
                <div className="bg-[#1c1c1c] rounded-xl px-4 py-3 max-w-sm flex gap-3 text-center text-xs text-gray-300 mb-6">
                    <p>
                        ID information is required for real person and age
                        verification, and it will be deleted from the system for
                        security purposes after verification is completed.
                    </p>
                </div>

                {/* Unique ID */}
                <p className="text-yellow-400 text-xs mb-12">
                    Unique Id: {user.unique_id}
                </p>

                {/* CTA Button */}
                <button
                    onClick={onStartVerification}
                    className="bg-red-500 transition
                               text-white text-sm font-medium
                               px-10 py-2 rounded-full mb-6"
                >
                    Start verification
                </button>
            </div>
        </div>
    );
}